import Vue from 'vue';
import App from './App.vue';

import "@/assets/fonts/font.css";
import "@/assets/global/index.css";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueParticles from 'vue-particles';


Vue.use(VueParticles);
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
    render: h => h(App),
}).$mount('#app')
